import { themeColor } from "./_helpers";

export const popoverTokens = {
  bg: themeColor({
    base: "{colors.whiteAlpha.300}",
    _themeBlack: "{colors.blackAlpha.800}",
    _themeWhite: "{colors.whiteAlpha.300}",
  }),
  border: themeColor({
    base: "{colors.primary.500}",
    _themeBlack: "{colors.white}",
    _themeWhite: "{colors.primary.500}",
  }),
  headerFg: themeColor({
    base: "{colors.neutral.900}",
    _themeBlack: "{colors.white}",
    _themeWhite: "{colors.neutral.900}",
  }),
};
